import * as React from 'react';
import { Formatters, Messages } from '../../gen-src/Localize';
import { generateId, Id } from '../common/Id';

export const extractRefreshTestId: Id = 'extract-refresh-information';
const lastExtractKey = 'last-extract';
const dateKey = 'date';

export interface ExtractRefreshProps {
  date?: Date;
  id?: Id;
  customStyle: React.CSSProperties;
}

export function ExtractRefreshComponent({ date, id, customStyle }: ExtractRefreshProps): React.ReactElement<ExtractRefreshProps> {
  let content: React.ReactNode;
  if (date) {

    content = [
      <span key={lastExtractKey} style={customStyle}>{Messages.CertifiedDatasource()}</span>,
      <span key={dateKey} style={customStyle}>{'(' + Formatters.formatMediumDateTimeWithoutMinutes(date) + ')'}</span>
    ];

  } else {
    content = Messages.CertifiedDatasourceLive();
  }
  return (
    <div data-tb-test-id={generateId(extractRefreshTestId, id)} style={customStyle}>
      {content}
    </div>
  );
}
